/**
 * @param value Original value from which discount is to be calculated.
 * @param discount Discount in "percents", e.g. 30 means 30%.
 * @returns
 */
export function calculateDiscount(value: number, discount: number): number {
	return (value * (100 - discount)) / 100;
}
